// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@5.2.7_webpack@4.47.0/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".cake_today_inner[data-v-7228e81c] {\n  padding: 0 0.9375rem;\n  width: 100%;\n  display: flex;\n}\n.cake_today_inner .image-slot[data-v-7228e81c] {\n  background: #f6f6f6;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n  height: 100%;\n  color: #dddee7;\n  font-size: 2.5rem;\n  border-radius: 0.625rem;\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
